<template>
	<div class="cart-order-sumary">
		<div class="cart-order-summary-main">
			<ul>
				<li>Products<span class="cart-summary-count"><strong><var>{{ productCount }}</var></strong></span></li>
				<li v-if="percentOffName && percentSavings > 0 && membership >= 1" class="text--blue" style="font-weight:bold"><strong class="memberSavings" style="font-weight:bold">{{ percentOffName }}</strong> <span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="minusCurrencySymbolLeft"><var>{{ percentSavings }}</var></span></li>
<li v-if="percentOffName && percentRetailSavings > 0 && !membership" class="text--blue" style="font-weight:bold"><strong class="memberSavings" style="font-weight:bold">{{ percentOffName }}</strong> <span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="minusCurrencySymbolLeft"><var>{{ percentRetailSavings }}</var></span></li>
				<li v-if="percentOffNameSecond && percentSavingsSecond > 0"><strong>{{ percentOffNameSecond }}</strong> <span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft"><var>-{{ percentSavingsSecond }}</var></span></li>
            <li v-if="couponAmount>0 && shippingOrderCount > 0" class="text--blue" style="font-weight:bold"><strong class="memberSavings" style="font-weight:bold">${{ couponAmount }} Off from<br>{{ enrollerFirst }}</strong> 
             <span>-<var :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft">{{ couponAmount }}</var></span>
            </li>
            <li v-if="giftCardAmount>0" class="text--blue" style="font-weight:bold"><strong class="memberSavings" style="font-weight:bold">Gift Certificate</strong>
             <span class="cart-summary-count">-<var :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft">{{ giftCardAmount }}</var></span>
            </li>
	    <li v-if="retailTotalPrice >= 0"><strong v-if="membership>=1">Retail Price</strong><strong v-else>Subtotal</strong>
               <strong>
                  <span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft">
                     <var v-if="membership>=1" style="text-decoration:line-through">{{ retailTotalPrice }}</var>
                     <var v-else>{{ retailTotalPrice }}</var>
                  </span>
               </strong>
            </li>
            <li v-if="totalMemberSave > 0 && membership >= 1 && totalAutoSave<.1" class="text--orange"><strong>Member Discount<span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft"><var>{{ totalMemberSave }}</var></span></strong></li>
            <li v-if="totalAutoSave > 0 && membership >= 1" class="text--orange"><strong>Member Discount <span class="cart-summary-count">(<span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft"><var>{{ totalAutoSave }})</var></span></span></strong></li>
            <div v-if="membership >= 1" class="cart-divider"></div>
	    <li v-if="membership >= 1 && totalAutoSave<.1" class="text--green"><strong>Total<span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft"><var>{{ totalPrice }}</var></span></strong></li>
            <li v-if="autoTotalPrice>0 && membership >= 1" class="text--green"><strong>Total<span :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft"><var>{{ autoTotalPrice }}</var></span></strong></li>
         </ul>
         <div v-if="totalMemberSave > 0 && !membership && retailOnly!=1" class="cart-divider"></div>         
            <div v-if="totalMemberSave > 0 && !membership && retailOnly!=1" class="cart-summary-like-to-save">
               <div class="text--blue cart-summary-like-to-save-text">
                  Would you like to save 
                  <strong class="text--orange" :data-currency-symbol-right="currencySymbolRight" :data-currency-symbol-left="currencySymbolLeft">
                     <var>{{ totalMemberSave }}</var>
                  </strong> 
                  today by becoming a member?
               </div>
               <div class="cart-summary-like-to-save-buttons">
                  <a class="cart-summary-like-to-save-yes" href=# @click="addMembershipToCart">Yes!</a>
                  <a class="cart-summary-like-to-save-learn" href="/membership">Learn&nbsp;More&nbsp;&#x2197;</a>
               </div>
            </div>       
            <div v-if="!isLoggedIn && totalMemberSave > 0 && !membership && retailOnly!=1" class="cart-summary-already-member">
               <div class="cart-summary-already-member-text">Already A Member?</div>
               <div class="cart-summary-already-member-link">
                  <a @click="openLoginModal()" href="#" >Login</a>
               </div>   
            </div>
		   </div>
         <div class="cart-summary-buttons">
            <ul>
               <li v-if="hasEnroller"><a onclick="cartCheckout()" data-dismiss="modal" data-toggle="modal" data-target="#myModal" href="#">CHECKOUT</a></li>
               <li v-else ><a onclick="cartCheckout()" data-dismiss="modal" data-toggle="modal" data-target="#myModal" href="#">CHECKOUT</a></li>
               <li><a href="products" class="cart-summary-continue-shopping">CONTINUE SHOPPING</a></li>
            </ul>
         </div>
         <login-modal
            :scriptName="scriptName"
            v-if="loginModalOpen"
            @modal-closed="closeLoginModal()"
         >
         </login-modal>
      </div>   
	</div>
</template>

<style>
	.cart-order-sumary span[data-currency-symbol-left], .cart-order-sumary span[data-currency-symbol-right] {
		float: right !important;
	}
   .cart-summary-notice {
      font-family: "Lato","Helvetica Neue","Helvetica",Helvetica,Arial,sans-serif;
      color:red;
      font-size:12px;
      margin-bottom:10px; 
   }
</style>

<script>
    import LoginModal from './LoginModal.vue'
    export default {
        props: {
	 totalPrice: String,
	 retailTotalPrice: String,
         autoTotalPrice: String,
         currencySymbolRight: String,
	 currencySymbolLeft: String,
         minusCurrencySymbolLeft: String,
	 productCount: Number,
         productFreeCount: Number,
         totalMemberSave: String,
         totalAutoSave: String,
	 isLoggedIn: Boolean,
	 percentSavings: String,
         percentRetailSavings: String,
	 percentOffName: String,
         percentSavingsSecond: String,
	 percentOffNameSecond: String,
         membership: Number,
         scriptName: String,
         coupon: Number,
         couponAmount: String,
         enrollerFirst: String,
         shippingOrderCount: Number,
         retailOnly:Number,
         giftCardAmount:Number
		},
        components: {
                'login-modal': LoginModal,
                },
        data: function () {
                        return {
                                loginModalOpen: false
                        }
                },
        methods: {
           addMembershipToCart () {
              shoppingCart.addToCart(1,1).then((x) => {
                  document.getElementById("openCart").click()
               })
            },
            openLoginModal() {
               console.log("opening login modal")
               this.loginModalOpen =true
               console.log(this.loginModalOpen)
            },
            closeLoginModal() {
               console.log("closing login modal")
               this.loginModalOpen= false
            },
        }
    }

</script>

<style>
</style>
